// extracted by mini-css-extract-plugin
export default {"inputClick":"ProfileInputImage_inputClick__dtaMo","profileInputClick":"ProfileInputImage_profileInputClick__+h9a3","inputIcon":"ProfileInputImage_inputIcon__OPUts"};